import styled from 'styled-components';

export const MainContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`;

export const ButtonContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    margin-top: 20px;
`;

export const Image = styled.img`
  height: 270px;
  width: 270px;
  object-fit: cover;
  border: 2px solid #ccc;
  border-radius: 4px;
`;

export const ImagesContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-around;
`;

export const ImagePlaceholder = styled.div`
  height: 270px;
  width: 270px;
  border: 2px dashed #aaa;
  background-color: #f9f9f9;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #777;
  font-size: 14px;
  font-style: italic;
`;

export const CategoryImage = styled.img`
    height: 200px;
    width: 200px;
`;

export const MainTitle = styled.h2`

`;

export const ImageFileInput = styled.input`
    margin: 20px auto;
`;

export const DeleteButton = styled.button`
  min-width: 165px;
  width: auto;
  height: 50px;
  letter-spacing: 0.5px;
  line-height: 50px;
  margin: 10px;
  padding: 0 35px 0 35px;
  font-size: 15px;
  background-color: red;
  color: white;
  text-transform: uppercase;
  font-family: 'Open Sans Condensed';
  font-weight: bolder;
  border: none;
  cursor: pointer;
  display: flex;
  justify-content: center;

  &:hover {
    background-color: white;
    color: black;
    border: 1px solid black;
  }
`;